export const localStore = {
	set: function (key:string, value:string) {
		return Promise.resolve().then(function () {
			localStorage.setItem(key, value);
		});
	},
	get: function (key:string) {
		return Promise.resolve().then(function () {
			return localStorage.getItem(key);
		});
	}
}